import { useAuth, ROLE_LABELS, AppRole } from "@/hooks/useAuth";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Eye } from "lucide-react";

/**
 * =============================================================================
 * RoleSimulator.tsx - Selettore ruolo effettivo/simulato
 * =============================================================================
 *
 * Mostra sempre il ruolo corrente nel footer della sidebar.
 * In sidebar il trigger del Select eredita colori chiari, quindi forziamo
 * i token semantici del design system sul trigger e sul value per garantire
 * contrasto corretto su sfondo chiaro.
 *
 * =============================================================================
 */
export function RoleSimulator() {
  const {
    highestRole,
    simulatedRole,
    setSimulatedRole,
    getAvailableSimulationRoles,
  } = useAuth();

  const availableRoles = getAvailableSimulationRoles();

  // Nessun ruolo assegnato: non mostrare il selettore
  if (!highestRole) {
    return null;
  }

  const handleRoleChange = (value: string) => {
    if (value === "real") {
      setSimulatedRole(null);
      return;
    }

    setSimulatedRole(value as AppRole);
  };

  return (
    <div className="flex items-center gap-2 min-w-0">
      <Eye className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <Select value={simulatedRole ?? "real"} onValueChange={handleRoleChange}>
        <SelectTrigger className="h-7 min-w-0 flex-1 bg-background text-[11px] text-foreground [&>span]:truncate [&>span]:text-foreground">
          <SelectValue
            className="text-foreground"
            placeholder="Visualizza come..."
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="real" className="text-xs">
            {ROLE_LABELS[highestRole]} (reale)
          </SelectItem>
          {availableRoles
            .filter((role) => role !== highestRole)
            .map((role) => (
              <SelectItem key={role} value={role} className="text-xs">
                {ROLE_LABELS[role]}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  );
}
